import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import { createApp } from 'vue';

import App from './App.vue';
import router from './router';

import 'primeicons/primeicons.css';
import './assets/main.css';

// Initialize AppSync client (only if endpoint is configured)
const appsyncEndpoint = import.meta.env.VITE_APP_AWS_APPSYNC_ENDPOINT;
if (appsyncEndpoint) {
  import('./services/appsync-client.js').then(({ appsyncClient }) => {
    appsyncClient.hydrated().catch((error: unknown) => {
      console.error('Failed to initialize AppSync client:', error);
    });
  });
} else {
  console.warn('AppSync endpoint not configured. GraphQL queries will use HTTP API instead.');
}

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(PrimeVue);

// Initialize auth store after Pinia is set up
import { useAuthStore } from './stores/auth.store.js';
const authStore = useAuthStore();

// Note: Tokens are now stored in localStorage for persistence across reloads
// PKCE values remain in sessionStorage (they're only needed during the OAuth flow)

// Initialize auth on app startup
authStore.initializeAuth();

app.mount('#app');
